import { render } from "./BaseToggleArrowButton.vue?vue&type=template&id=7ff651f2&scoped=true"
import script from "./BaseToggleArrowButton.vue?vue&type=script&lang=js"
export * from "./BaseToggleArrowButton.vue?vue&type=script&lang=js"

import "./BaseToggleArrowButton.vue?vue&type=style&index=0&id=7ff651f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff651f2"]])

export default __exports__